import { render } from "./AuthyFront.vue?vue&type=template&id=33cadbee&scoped=true"
import script from "./AuthyFront.vue?vue&type=script&lang=js"
export * from "./AuthyFront.vue?vue&type=script&lang=js"

import "./AuthyFront.vue?vue&type=style&index=0&id=33cadbee&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33cadbee"]])

export default __exports__